// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/DroidSans-Bold-webfont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/DroidSans-webfont.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@font-face {
  font-family: "droid_sansbold";
  src: local("DroidSans-Bold-webfont.ttf"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "droid_sansregular";
  src: local("DroidSans-webfont.ttf"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
*,
*::before,
*::after {
  box-sizing: border-box;
}

* {
  margin: 0;
  padding: 0;
}

ul[role=list],
ol[role=list] {
  list-style: none;
}

html:focus-within {
  scroll-behavior: smooth;
}

a:not([class]) {
  text-decoration-skip-ink: auto;
}

img,
picture,
svg,
video,
canvas {
  max-width: 100%;
  height: auto;
  vertical-align: middle;
  font-style: italic;
  background-repeat: no-repeat;
  background-size: cover;
}

input,
button,
textarea,
select {
  font: inherit;
}

@media (prefers-reduced-motion: reduce) {
  html:focus-within {
    scroll-behavior: auto;
  }
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
    transition: none;
  }
}
body,
html {
  height: 100%;
  scroll-behavior: smooth;
}

.layout {
  display: flex;
}

.workspace-container {
  display: block;
  padding-right: 1rem;
}

.create-workspace {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  border-radius: 8px;
  border: none;
  background-color: #0d47a0;
  color: #fff;
  font-size: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  width: 150px;
  height: 138px;
  padding-bottom: 22px !important;
}

.create-workspace-icon {
  font-size: 40px;
  color: #fff;
  padding-bottom: 12px;
}

.modal-body {
  height: 100%;
}

.project-table-data table th .table-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.project-table-data table td {
  text-align: left;
}

.btn-close {
  transition: all 0.3s ease-in-out;
}

.btn-close:hover {
  transform: rotate(180deg);
}

.modal-content {
  height: calc(100vh - 100px);
}

select {
  margin: 0;
  box-sizing: border-box;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

select.form-control-select {
  background-image: linear-gradient(45deg, transparent 50%, #333 50%), linear-gradient(135deg, #333 50%, transparent 50%);
  background-position: calc(100% - 23px) calc(1em + 2px), calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;
  background-size: 8px 8px, 8px 8px, 0px 2.5em;
  background-repeat: no-repeat;
  display: flex;
  width: 100%;
  max-width: 250px;
  border-radius: 8px;
  border: 1px solid #ddd;
  padding: 12px;
}
@media screen and (max-width: 767px) and (orientation: portrait) {
  select.form-control-select {
    max-width: 100%;
    width: 100%;
  }
}

select.form-control-select:focus {
  border-color: #e0e3e8;
  outline: 0;
}

.tdLink {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  text-decoration: underline;
  color: #0d47a0 !important;
  font-weight: 700;
}
.tdLink .form-control {
  max-height: 34px;
}

.ws-container {
  counter-reset: numeric;
}
.ws-container .ws-select {
  position: relative;
}
.ws-container .ws-select .multi-select-dropdown,
.ws-container .ws-select .select-frequency,
.ws-container .ws-select .select-date {
  padding-left: 30px;
  width: 230px;
}
@media screen and (max-width: 767px) and (orientation: portrait) {
  .ws-container .ws-select .multi-select-dropdown,
  .ws-container .ws-select .select-frequency,
  .ws-container .ws-select .select-date {
    max-width: 100%;
    width: 100%;
  }
}
@media screen and (max-width: 767px) and (orientation: portrait) {
  .ws-container .ws-select .multi-select-dropdown .form-control,
  .ws-container .ws-select .select-frequency .form-control,
  .ws-container .ws-select .select-date .form-control {
    max-width: 100%;
    width: 100%;
  }
}
.ws-container .ws-select::before {
  counter-increment: numeric;
  content: counter(numeric);
  width: 24px;
  height: 24px;
  font-size: 14px;
  color: #0d47a0;
  background-color: #fff;
  border: 1px solid #0d47a0;
  border-radius: 50%;
  padding: 0px;
  position: absolute;
  top: 12px;
  left: 12px;
  display: block;
  text-align: center;
  aspect-ratio: 1;
}
.ws-container .ws-select::after {
  content: "→";
  width: 30px;
  height: 30px;
  background-color: #fff;
  color: #ccc;
  position: absolute;
  top: 4px;
  left: 75%;
  font-size: 30px;
}
@media screen and (max-width: 767px) {
  .ws-container .ws-select::after {
    content: none;
  }
}
.ws-container .ws-select:last-child::after {
  content: none;
}
.ws-container .ws-select:nth-child(4)::after, .ws-container .ws-select:nth-child(6)::after, .ws-container .ws-select:nth-child(5)::after {
  left: 90%;
}

.ws-container .ws-select .custom-width {
  width: 90% !important;
}
@media screen and (max-width: 767px) and (orientation: portrait) {
  .ws-container .ws-select .custom-width {
    max-width: 100%;
    width: 100% !important;
  }
}

.result-container {
  display: block;
  border: 1px solid #e4e5e6;
  padding: 0.5rem 0;
  margin: 0 0.5rem;
  background-color: #fff;
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.13);
}

.selection-Details {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  border-bottom: 1px solid #e4e5e6;
  padding-bottom: 0.5rem;
  padding-left: 0.5rem;
  display: block;
  width: 100%;
  margin-bottom: 0.5rem;
}

.selected-item-container {
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  padding: 0 0.5rem;
}
.selected-item-container .selected-list-items {
  display: flex;
  flex-direction: column;
  width: calc(16.6666666667% - 0.5rem);
  border-right: 1px solid #e4e5e6;
}
.selected-item-container .selected-list-items:last-child {
  border-right: none;
}
.selected-item-container .selected-list-items h5 {
  font-family: "Poppins", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  font-size: 14px !important;
  display: flex;
  padding: 0.5rem;
  justify-content: space-between;
  background-color: #f8f9fa;
}
.selected-item-container .selected-list-items h5 .selectedCount {
  display: flex;
}
.selected-item-container .selected-list-items ul {
  margin: 0;
  padding: 0.5rem;
}
.selected-item-container .selected-list-items ul li {
  list-style-type: none;
  display: flex;
  font-size: 14px;
  line-height: 2;
}

.update-btn {
  background-color: #0d47a0;
  font-weight: bold;
  color: #fff;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  transition: all 0.3s ease-in-out;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  white-space: nowrap;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
}

.modal-title {
  font-weight: bold;
}

@media (max-width: 767px) {
  .workspace-container {
    padding: 0 0.75rem;
  }
  .modal-content {
    height: calc(100vh - 40px);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/workSpace/workSpace.scss","webpack://./src/assets/mixins/fonts.scss","webpack://./src/assets/mixins/reset.scss","webpack://./src/assets/mixins/colors.scss","webpack://./src/assets/mixins/mixins.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACEhB;EACE,6BAAA;EACA,oGAAA;EAEA,mBAAA;EACA,kBAAA;ADCF;ACCA;EACE,gCAAA;EACA,+FAAA;EAEA,mBAAA;EACA,kBAAA;ADAF;AEdA;;;EAGE,sBAAA;AFgBF;;AEbA;EACE,SAAA;EACA,UAAA;AFgBF;;AEbA;;EAEE,gBAAA;AFgBF;;AEbA;EACE,uBAAA;AFgBF;;AEbA;EACE,8BAAA;AFgBF;;AEbA;;;;;EAKE,eAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,4BAAA;EACA,sBAAA;AFgBF;;AEbA;;;;EAIE,aAAA;AFgBF;;AEbA;EACE;IACE,qBAAA;EFgBF;EEdA;;;IAGE,qCAAA;IACA,uCAAA;IACA,sCAAA;IACA,gCAAA;IACA,gBAAA;EFgBF;AACF;AEbA;;EAEE,YAAA;EACA,uBAAA;AFeF;;AA5EA;EACE,aAAA;AA+EF;;AA7EA;EACE,cAAA;EACA,mBAAA;AAgFF;;AA9EA;ECoBE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EDrBA,kBAAA;EACA,YAAA;EACA,yBGZc;EHad,WGTM;EHUN,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,+BAAA;AAoFF;;AAlFA;EACE,eAAA;EACA,WGrBM;EHsBN,oBAAA;AAqFF;;AAnFA;EACE,YAAA;AAsFF;;AA7DM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAgER;AA7DI;EACE,gBAAA;AA+DN;;AA1DA;EACE,gCAAA;AA6DF;;AA1DA;EACE,yBAAA;AA6DF;;AA1DA;EACE,2BAAA;AA6DF;;AA1DA;EACE,SAAA;EAGA,sBAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;AA6DF;;AA1DA;EACE,uHAAA;EAEA,mHAAA;EAEA,4CAAA;EACA,4BAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;AA2DF;AA1DE;EAbF;IAcI,eAAA;IACA,WAAA;EA6DF;AACF;;AA1DA;EACE,qBAAA;EACA,UAAA;AA6DF;;AA3DA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;EACA,0BAAA;EACA,yBAAA;EACA,gBAAA;AA8DF;AA7DE;EACE,gBAAA;AA+DJ;;AA3DA;EACE,sBAAA;AA8DF;AA7DE;EACE,kBAAA;AA+DJ;AA9DI;;;EAGE,kBAAA;EACA,YAAA;AAgEN;AA/DM;EALF;;;IAMI,eAAA;IACA,WAAA;EAoEN;AACF;AAlEQ;EADF;;;IAEI,eAAA;IACA,WAAA;EAuER;AACF;AApEI;EACE,0BAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAsEN;AApEI;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,sBGpKE;EHqKF,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;AAsEN;AArEM;EAVF;IAWI,aAAA;EAwEN;AACF;AAtEI;EACE,aAAA;AAwEN;AAtEI;EAGE,SAAA;AAsEN;;AA/DI;EACE,qBAAA;AAkEN;AAjEM;EAFF;IAGI,eAAA;IACA,sBAAA;EAoEN;AACF;;AA/DA;EACE,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EI3MA,sBDCM;ECAN,qBAAA;EACA,wCAAA;AJ8QF;;AAlEA;ECrLE,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EDoLA,gCAAA;EACA,sBAAA;EACA,oBAAA;EACA,cAAA;EACA,WAAA;EACA,qBAAA;AAwEF;;AAtEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;AAyEF;AAxEE;EACE,aAAA;EACA,sBAAA;EAEA,oCAAA;EACA,+BAAA;AAyEJ;AAxEI;EACE,kBAAA;AA0EN;AAxEI;EC5MF,kCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;ED2MI,0BAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,yBAAA;AA6EN;AA5EM;EACE,aAAA;AA8ER;AA1EI;EACE,SAAA;EACA,eAAA;AA4EN;AA3EM;EACE,qBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;AA6ER;;AAvEA;EACE,yBAAA;EACA,iBAAA;EACA,WGhQM;EHiQN,qBAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AA0EF;;AAxEA;EACE,iBAAA;AA2EF;;AAzEA;EACE;IACE,kBAAA;EA4EF;EA1EA;IACE,0BAAA;EA4EF;AACF","sourcesContent":["@charset \"UTF-8\";\n@import url(\"https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@font-face {\n  font-family: \"droid_sansbold\";\n  src: local(\"DroidSans-Bold-webfont.ttf\"), url(\"../../assets/fonts/DroidSans-Bold-webfont.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"droid_sansregular\";\n  src: local(\"DroidSans-webfont.ttf\"), url(\"../../assets/fonts/DroidSans-webfont.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n}\n\nul[role=list],\nol[role=list] {\n  list-style: none;\n}\n\nhtml:focus-within {\n  scroll-behavior: smooth;\n}\n\na:not([class]) {\n  text-decoration-skip-ink: auto;\n}\n\nimg,\npicture,\nsvg,\nvideo,\ncanvas {\n  max-width: 100%;\n  height: auto;\n  vertical-align: middle;\n  font-style: italic;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html:focus-within {\n    scroll-behavior: auto;\n  }\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n    transition: none;\n  }\n}\nbody,\nhtml {\n  height: 100%;\n  scroll-behavior: smooth;\n}\n\n.layout {\n  display: flex;\n}\n\n.workspace-container {\n  display: block;\n  padding-right: 1rem;\n}\n\n.create-workspace {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  border-radius: 8px;\n  border: none;\n  background-color: #0d47a0;\n  color: #fff;\n  font-size: 1rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n  width: 150px;\n  height: 138px;\n  padding-bottom: 22px !important;\n}\n\n.create-workspace-icon {\n  font-size: 40px;\n  color: #fff;\n  padding-bottom: 12px;\n}\n\n.modal-body {\n  height: 100%;\n}\n\n.project-table-data table th .table-heading {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.project-table-data table td {\n  text-align: left;\n}\n\n.btn-close {\n  transition: all 0.3s ease-in-out;\n}\n\n.btn-close:hover {\n  transform: rotate(180deg);\n}\n\n.modal-content {\n  height: calc(100vh - 100px);\n}\n\nselect {\n  margin: 0;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\nselect.form-control-select {\n  background-image: linear-gradient(45deg, transparent 50%, #333 50%), linear-gradient(135deg, #333 50%, transparent 50%);\n  background-position: calc(100% - 23px) calc(1em + 2px), calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;\n  background-size: 8px 8px, 8px 8px, 0px 2.5em;\n  background-repeat: no-repeat;\n  display: flex;\n  width: 100%;\n  max-width: 250px;\n  border-radius: 8px;\n  border: 1px solid #ddd;\n  padding: 12px;\n}\n@media screen and (max-width: 767px) and (orientation: portrait) {\n  select.form-control-select {\n    max-width: 100%;\n    width: 100%;\n  }\n}\n\nselect.form-control-select:focus {\n  border-color: #e0e3e8;\n  outline: 0;\n}\n\n.tdLink {\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.5rem;\n  text-decoration: underline;\n  color: #0d47a0 !important;\n  font-weight: 700;\n}\n.tdLink .form-control {\n  max-height: 34px;\n}\n\n.ws-container {\n  counter-reset: numeric;\n}\n.ws-container .ws-select {\n  position: relative;\n}\n.ws-container .ws-select .multi-select-dropdown,\n.ws-container .ws-select .select-frequency,\n.ws-container .ws-select .select-date {\n  padding-left: 30px;\n  width: 230px;\n}\n@media screen and (max-width: 767px) and (orientation: portrait) {\n  .ws-container .ws-select .multi-select-dropdown,\n  .ws-container .ws-select .select-frequency,\n  .ws-container .ws-select .select-date {\n    max-width: 100%;\n    width: 100%;\n  }\n}\n@media screen and (max-width: 767px) and (orientation: portrait) {\n  .ws-container .ws-select .multi-select-dropdown .form-control,\n  .ws-container .ws-select .select-frequency .form-control,\n  .ws-container .ws-select .select-date .form-control {\n    max-width: 100%;\n    width: 100%;\n  }\n}\n.ws-container .ws-select::before {\n  counter-increment: numeric;\n  content: counter(numeric);\n  width: 24px;\n  height: 24px;\n  font-size: 14px;\n  color: #0d47a0;\n  background-color: #fff;\n  border: 1px solid #0d47a0;\n  border-radius: 50%;\n  padding: 0px;\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  display: block;\n  text-align: center;\n  aspect-ratio: 1;\n}\n.ws-container .ws-select::after {\n  content: \"→\";\n  width: 30px;\n  height: 30px;\n  background-color: #fff;\n  color: #ccc;\n  position: absolute;\n  top: 4px;\n  left: 75%;\n  font-size: 30px;\n}\n@media screen and (max-width: 767px) {\n  .ws-container .ws-select::after {\n    content: none;\n  }\n}\n.ws-container .ws-select:last-child::after {\n  content: none;\n}\n.ws-container .ws-select:nth-child(4)::after, .ws-container .ws-select:nth-child(6)::after, .ws-container .ws-select:nth-child(5)::after {\n  left: 90%;\n}\n\n.ws-container .ws-select .custom-width {\n  width: 90% !important;\n}\n@media screen and (max-width: 767px) and (orientation: portrait) {\n  .ws-container .ws-select .custom-width {\n    max-width: 100%;\n    width: 100% !important;\n  }\n}\n\n.result-container {\n  display: block;\n  border: 1px solid #e4e5e6;\n  padding: 0.5rem 0;\n  margin: 0 0.5rem;\n  background-color: #fff;\n  background-color: #fff;\n  border-radius: 0.5rem;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.13);\n}\n\n.selection-Details {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  border-bottom: 1px solid #e4e5e6;\n  padding-bottom: 0.5rem;\n  padding-left: 0.5rem;\n  display: block;\n  width: 100%;\n  margin-bottom: 0.5rem;\n}\n\n.selected-item-container {\n  display: flex;\n  flex-flow: row wrap;\n  width: 100%;\n  padding: 0 0.5rem;\n}\n.selected-item-container .selected-list-items {\n  display: flex;\n  flex-direction: column;\n  width: calc(16.6666666667% - 0.5rem);\n  border-right: 1px solid #e4e5e6;\n}\n.selected-item-container .selected-list-items:last-child {\n  border-right: none;\n}\n.selected-item-container .selected-list-items h5 {\n  font-family: \"Poppins\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  font-size: 14px !important;\n  display: flex;\n  padding: 0.5rem;\n  justify-content: space-between;\n  background-color: #f8f9fa;\n}\n.selected-item-container .selected-list-items h5 .selectedCount {\n  display: flex;\n}\n.selected-item-container .selected-list-items ul {\n  margin: 0;\n  padding: 0.5rem;\n}\n.selected-item-container .selected-list-items ul li {\n  list-style-type: none;\n  display: flex;\n  font-size: 14px;\n  line-height: 2;\n}\n\n.update-btn {\n  background-color: #0d47a0;\n  font-weight: bold;\n  color: #fff;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  transition: all 0.3s ease-in-out;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  white-space: nowrap;\n  border: none;\n  border-radius: 4px;\n  padding: 6px 12px;\n}\n\n.modal-title {\n  font-weight: bold;\n}\n\n@media (max-width: 767px) {\n  .workspace-container {\n    padding: 0 0.75rem;\n  }\n  .modal-content {\n    height: calc(100vh - 40px);\n  }\n}","@import url(\"https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap\");\r\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\r\n@font-face {\r\n  font-family: \"droid_sansbold\";\r\n  src: local(\"DroidSans-Bold-webfont.ttf\"),\r\n    url(\"../../assets/fonts/DroidSans-Bold-webfont.ttf\") format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n@font-face {\r\n  font-family: \"droid_sansregular\";\r\n  src: local(\"DroidSans-webfont.ttf\"),\r\n    url(\"../../assets/fonts/DroidSans-webfont.ttf\") format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n@mixin primeFont() {\r\n  font-family: \"Abril Fatface\", serif;\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n@mixin secondaryFont() {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-optical-sizing: auto;\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n@mixin secondaryFontBold() {\r\n  font-family: \"Poppins\", sans-serif;\r\n  font-optical-sizing: auto;\r\n  font-weight: 500;\r\n  font-style: normal;\r\n}\r\n","*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nul[role=\"list\"],\r\nol[role=\"list\"] {\r\n  list-style: none;\r\n}\r\n\r\nhtml:focus-within {\r\n  scroll-behavior: smooth;\r\n}\r\n\r\na:not([class]) {\r\n  text-decoration-skip-ink: auto;\r\n}\r\n\r\nimg,\r\npicture,\r\nsvg,\r\nvideo,\r\ncanvas {\r\n  max-width: 100%;\r\n  height: auto;\r\n  vertical-align: middle;\r\n  font-style: italic;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n}\r\n\r\ninput,\r\nbutton,\r\ntextarea,\r\nselect {\r\n  font: inherit;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  html:focus-within {\r\n    scroll-behavior: auto;\r\n  }\r\n  *,\r\n  *::before,\r\n  *::after {\r\n    animation-duration: 0.01ms !important;\r\n    animation-iteration-count: 1 !important;\r\n    transition-duration: 0.01ms !important;\r\n    scroll-behavior: auto !important;\r\n    transition: none;\r\n  }\r\n}\r\n\r\nbody,\r\nhtml {\r\n  height: 100%;\r\n  scroll-behavior: smooth;\r\n}\r\n","$primary-color: #0d47a0;\r\n$primary-color-hover: #093373;\r\n$secondary-blue: #93cfff;\r\n$background-color: #f4f6fa;\r\n$white: #fff;\r\n$text-color: #2f2f2f;\r\n$text-dark-color: #072148;\r\n$table-stroke-color: #dfdfdf;\r\n$stroke-color: #949494;\r\n$input-stroke: #e4e8e9;\r\n$text-warning: #ed8b00;\r\n$text-danger: #cc3201;\r\n$text-success: #339900;\r\n$tooltip-bg: #0d47a0;\r\n$tooltip-color: #ffffff;\r\n$button-color: #ff6b00;\r\n","@import \"variables\", \"colors\", \"fonts\", \"reset\";\r\n\r\n@mixin boxWithShadow() {\r\n  background-color: $white;\r\n  border-radius: 0.5rem;\r\n  box-shadow: 0 0 20px rgba(0, 0, 0, 13%);\r\n}\r\n@mixin brandScores() {\r\n  background-color: $white;\r\n  border-radius: 0.5rem;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 12%);\r\n  padding: 0.675rem;\r\n}\r\n\r\n@mixin pageTitle() {\r\n  @include primeFont();\r\n  font-size: 2rem;\r\n  color: $primary-color;\r\n  line-height: 2.5rem;\r\n  margin-top: 0.5rem;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n@mixin boxSubTitle() {\r\n  @include secondaryFontBold;\r\n  font-size: 1rem;\r\n  color: $text-color;\r\n  line-height: 1.2;\r\n  margin-bottom: .875rem;\r\n  display: flex;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
